// Application Constants
// Centralizing hardcoded values for better maintainability

// App Name - used in Main.tsx and Index.tsx
export const APP_NAME = 'Alex Brinker';

// Personal Information
export const PERSONAL_INFO = {
  NAME: 'Alex Brinker',
  EMAIL: 'alex@alexbrinker.com',
  TITLE: 'Senior Architect',
  COMPANY: 'Slalom Build',
  COMPANY_URL: 'https://www.slalombuild.com/',
  LOCATION: 'Chicago, IL',
  BIRTH_DATE: '1989-03-29T07:24:00',
} as const;

// Website URLs
export const SITE_URLS = {
  BASE_URL: 'https://www.alexbrinker.com',
  SITEMAP_SCHEMA: 'http://www.sitemaps.org/schemas/sitemap/0.9',
  SCHEMA_ORG: 'https://schema.org',
} as const;

// Social Media Links
export const SOCIAL_LINKS = {
  GITHUB: 'https://github.com/alexbrinker',
  LINKEDIN: 'https://www.linkedin.com/in/alexbrinker',
  TWITTER: 'https://twitter.com/alexbrinker',
  FACEBOOK: 'https://facebook.com/alexbrinker',
  INSTAGRAM: 'https://www.instagram.com/alexbrinker',
} as const;

// External API URLs
export const API_URLS = {
  GITHUB_REPO: 'https://api.github.com/repos/alexbrinker/alexbrinker',
  OLD_GITHUB_REPO: 'https://api.github.com/repos/mldangelo/personal-site', // Legacy - should be updated
} as const;

// External Links
export const EXTERNAL_LINKS = {
  MAPS_COUNTRIES_VISITED:
    'https://www.google.com/maps/d/embed?mid=1iBBTscqateQ93pWFVfHCUZXoDu8&z=2',
  OLENICK_LINKEDIN: 'https://www.linkedin.com/company/qualitestolenick/',
  JSON_RESUME_SCHEMA: 'https://jsonresume.org/schema/',
} as const;

// GitHub Repository Links
export const GITHUB_REPO_LINKS = {
  STARGAZERS: `${SOCIAL_LINKS.GITHUB}/alexbrinker/stargazers`,
  NETWORK: `${SOCIAL_LINKS.GITHUB}/alexbrinker/network`,
  ISSUES: `${SOCIAL_LINKS.GITHUB}/alexbrinker/issues`,
  COMMITS: `${SOCIAL_LINKS.GITHUB}/alexbrinker/commits`,
  CONTRIBUTORS: `${SOCIAL_LINKS.GITHUB}/alexbrinker/graphs/contributors`,
} as const;

// SEO & Metadata
export const SEO_METADATA = {
  DEFAULT_TITLE: 'Alex Brinker',
  TITLE_TEMPLATE: '%s | Alex Brinker',
  DEFAULT_DESCRIPTION:
    'Alex Brinker - Senior Architect at Slalom Build specializing in quality engineering, test automation, and .NET development. Based in Chicago, leading teams in building robust, scalable software solutions.',
  DEFAULT_IMAGE: '/images/me.png',
  TWITTER_HANDLE: '@alexbrinker',
} as const;

// Page-specific Descriptions
export const PAGE_DESCRIPTIONS = {
  HOME: 'Alex Brinker - Senior Architect at Slalom Build specializing in quality engineering, test automation, and .NET development. Based in Chicago, leading teams in building robust, scalable software solutions.',
  ABOUT: 'Learn about Alex Brinker',
  CONTACT:
    'Get in touch with Alex Brinker - Senior Architect at Slalom Build. Connect for consulting, architecture discussions, or collaboration opportunities.',
  PROJECTS:
    "Explore Alex Brinker's portfolio of software architecture and quality engineering projects including AI-powered test automation, API platforms, and enterprise solutions.",
  RESUME:
    "Alex Brinker's professional resume - Senior Architect at Slalom Build with expertise in quality engineering, test automation, .NET development, and AI-powered solutions.",
  STATS: 'Some statistics about Alex Brinker and www.alexbrinker.com',
} as const;

// Professional Headlines
export const PROFESSIONAL_HEADLINES = {
  PRIMARY: 'Senior Architect | Quality Engineering Leader | AI Enthusiast',
  SIDEBAR: 'Quality Engineering Leader', // Note: Inconsistency found - should align with primary
  META_DESCRIPTION_VP: 'VP of Engineering at Smile Identity', // Note: Outdated - needs update
} as const;

// Numbers & Magic Values
export const NUMBERS = {
  MAX_QUEUE_SIZE: 10,
  ERROR_LOG_RETENTION: 10,
  AGE_UPDATE_INTERVAL_MS: 25,
  COUNTRIES_VISITED: 53,
  LINES_OF_CODE: 2607,
  MS_IN_YEAR: 31556925190.079998,

  // Project Statistics
  TEST_COVERAGE_PERCENTAGE: 95,
  MAINTENANCE_REDUCTION_PERCENTAGE: 60,
  UPTIME_PERCENTAGE: 99.9,
  BUG_REDUCTION_PERCENTAGE: 75,
  VELOCITY_IMPROVEMENT_PERCENTAGE: 40,
  DEPLOYMENT_TIME_REDUCTION_PERCENTAGE: 70,
  TEST_COVERAGE_IMPROVEMENT_PERCENTAGE: 60,
  TEAMS_SERVED: 50,
} as const;

// Date Values
export const DATES = {
  SLALOM_START: '2016-05-31',
  OLENICK_START: '2012-07-09',
  OLENICK_END: '2016-05-27',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NOT_FOUND_TITLE: '404 Not Found',
  PAGE_NOT_FOUND: 'Page not found',
} as const;

// Email Configuration
export const EMAIL_CONFIG = {
  DOMAIN: '@alexbrinker.com',
  DEFAULT_PREFIX: 'hi',
} as const;

// Component Configuration
export const COMPONENT_CONFIG = {
  ERROR_BOUNDARY_ICON_SIZE: 64,
  SVG_VIEWBOX: '0 0 24 24',
  CIRCLE_RADIUS: 10,
  CIRCLE_CENTER: 12,
} as const;

// Course Links (Stanford)
export const COURSE_LINKS = {
  CONVEX_OPTIMIZATION: 'http://stanford.edu/class/ee364a/',
  MACHINE_LEARNING: 'http://cs229.stanford.edu/',
  COMPUTER_VISION: 'http://cs231n.stanford.edu/',
  EMBEDDED_SYSTEMS:
    'http://scpd.stanford.edu/search/publicCourseSearchDetails.do;jsessionid=561188A06434D7D97953C4706DE12831?method=load&courseId=11685',
} as const;

// Build & Development
export const BUILD_CONFIG = {
  LINTER_WARNINGS: 0,
  OPEN_ISSUES_COUNT: 0,
} as const;
